/* unplugin-vue-components disabled */import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=dbb85560&lang=scss"

const __exports__ = script;

export default __exports__